import React, { useContext, useState } from 'react'
import { Formik } from 'formik'
import { Button, Form, Grid, GridCell, NotificationManagerContext, NotificationInline,
   Spacer, Switch, Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import { Input } from 'src/components/ConnectedForm'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'

const AppSettingsAbout = () => {
   const { appId } = useParams()
   const { showNotification } = useContext(NotificationManagerContext)
   const theme = useContext(ThemeContext)
   const [error, setError] = useState(null)

   const { organization } = useOrganization()
   const { updateOrganization } = useUpdateOrganization()
   const app = organization.apps.find(a => a.id === appId)

   const handleUpdateApp = async (values, actions) => {
      setError(null)

      try {
         await updateOrganization({
            apps: [{
               operation: 'update',
               update: {
                  id: app.id,
                  ...values
               }
            }]
         })

         showNotification({
            message: 'Changes saved successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         setError(err)
      } finally {
         if (actions) {
            actions.setSubmitting(false)
         }
      }
   }

   return (
      <>
         <View
            display="flex"
            width="100%"
            backgroundColor="#fff"
            padding="20px">
            <View flex="1 1 auto" paddingRight="60px">
               <Text size="2" weight="medium">
                  {`${app.name} is ${app.enabled ? 'Enabled' : 'Disabled'}`}
               </Text>
               <Spacer size="1" />
               <Text size="1.5" color="#666">
                  {app.enabled && (
                     'Turn this off if you would like to disable this app. Disabling this app will hide this app and all its contents for all users.'
                  )}
                  {!app.enabled && (
                     'Turn this on if you would like to enable this app.'
                  )}
               </Text>
            </View>
            <View flex="0 0 auto">
               <Switch
                  highlightColor="#0dd16d"
                  defaultChecked={app.enabled}
                  onChange={() => handleUpdateApp({ enabled: !app.enabled })}
               />
            </View>
         </View>
         <Spacer size="3" />
         <Formik
            initialValues={{ name: app.name }}
            onSubmit={handleUpdateApp}
            render={({ handleSubmit, isSubmitting }) => (
               <Form
                  elementAppearance="plain"
                  elementBackgroundColor="#eee"
                  elementFocusBackgroundColor="#f3f3f3"
                  onSubmit={handleSubmit}>
                  {error && (
                     <NotificationInline
                        borderRadius="3px"
                        textSize="2"
                        type="error"
                        title="Error"
                        message={error.graphQLErrors.map(e => e.message).join(', ') || error.message}
                     />
                  )}
                  <View
                     width="100%"
                     padding="20px 20px 15px 20px"
                     borderRadius="3px"
                     backgroundColor="#fff">
                     <Grid spacing="10px">
                        <GridCell colspan="4">
                           <Text size="2" weight="medium">
                              App Name
                           </Text>
                           <Text size="1.5" color="#999">
                              (max 100 characters)
                           </Text>
                        </GridCell>
                        <GridCell colspan="8">
                           <Input
                              maxLength="100"
                              size="md"
                              name="name"
                              placeholder="App Name"
                           />
                        </GridCell>
                        <GridCell colspan="12">
                           <View
                              display="flex"
                              justifyContent="flex-end"
                              width="100%"
                              borderTop="1px solid #eee"
                              paddingTop="10px">
                              <Button
                                 type="submit"
                                 name="Save Changes"
                                 mode={isSubmitting ? 'loading' : 'normal'}
                                 color={theme.protoSettingsHighlightBackgroundColor}
                                 textColor={theme.protoSettingsHighlightForegroundColor}
                                 textWeight="medium"
                                 size="sm"
                                 textSize="0.9"
                                 padding="25px"
                              />
                           </View>
                        </GridCell>
                     </Grid>
                  </View>
               </Form>
            )}
         />
      </>
   )
}

export default AppSettingsAbout
